<div class="header" (click)="toggle()">
  <div class="title">{{ title }}</div>
  <span class="badge" *ngIf="badge">{{ badge }}</span>
  <i class="icon icon-chevron-down" *ngIf="expansion && !opened"></i>
  <i class="icon icon-chevron-up" *ngIf="expansion && opened"></i>
</div>
<div class="content" *ngIf="!expansion || opened"><ng-content></ng-content></div>

